import { subscribe } from '../common/errors/sagas';
import { notificationError } from '../common/errors/notificationTypes';

const pre = 'SETTINGS/';

export const USER_PROFILE_LOADED = `${pre}USER_PROFILE_LOADED`;
export const SET_USER_PROFILE_LOADING = `${pre}SET_USER_PROFILE_LOADING`;
export const SET_USER_ROLE = `${pre}SET_USER_ROLE`;
export const SET_USER_INFO = `${pre}SET_USER_INFO`;
export const SET_USER_PROFILE_INITIALISED = `${pre}SET_USER_PROFILE_INITIALISED`;
export const STATUS_PAGE_LOADED = `${pre}STATUS_PAGE_LOADED`;
export const SET_STATUS_PAGE_LOADING = `${pre}SET_STATUS_PAGE_LOADING`;
export const SET_STATUS_PAGE_INITIALISED = `${pre}SET_STATUS_PAGE_INITIALISED`;
export const REFRESH_STATUS_PAGE = `${pre}REFRESH_STATUS_PAGE`;
export const SET_SQL_STATUS = `${pre}SET_SQL_STATUS`;
export const SET_SQL_STATUS_FOR_IMAGE = `${pre}SET_SQL_STATUS_FOR_IMAGE`;


export const UserProfileConnected = () => ({
    type: USER_PROFILE_LOADED,    
});

export const setUserProfileLoading = loading => ({
    type: SET_USER_PROFILE_LOADING,
    loading
});

export const setUserRole = (role) => ({
    type: SET_USER_ROLE,
    role
});

export const setUserInfo = (info) => ({
    type: SET_USER_INFO,
    info
});

export const setUserProfileInitialised = initialised => ({
    type: SET_USER_PROFILE_INITIALISED,
    initialised
});

export const StatusPageConnected = () => ({
    type: STATUS_PAGE_LOADED,    
});

export const setStatusPageLoading = loading => ({
    type: SET_STATUS_PAGE_LOADING,
    loading
});

export const setStatusPageInitialised = initialised => ({
    type: SET_STATUS_PAGE_INITIALISED,
    initialised
});

export const RefreshData = () => ({
    type: REFRESH_STATUS_PAGE
});

export const setSqlStatus = (rows) => ({
    type: SET_SQL_STATUS,
    rows
});

export const setSqlStatusForImage = (status) => ({
    type: SET_SQL_STATUS_FOR_IMAGE,
    status
});
